<a [href]="activityItem.url" target="_blank">
<div class="gridlistItem">
    <div class="gli-date">
        <div>{{activityItem.date}}</div>
    </div>

    <div class="gli-sep">
        <span>-</span>
    </div>
    <div class="gli-data">
        <div class="mainData">
            <div>{{activityItem.mainEvent}}</div>
        </div>
        <div class="mainDataUser">
            <div>{{activityItem.supportInfo}}</div>
        </div>
    </div>
</div>
</a>
